
import { apiBaseUrl } from './constants'
// import moment from 'moment'

function getHeaders () {
  return new Headers({
    'Content-Type': 'application/json'
  })
}

export default {
  getTranslations (range) {
    return fetch(`${apiBaseUrl}/translations`, {
      method: 'GET',
      headers: getHeaders()
    })
    .then(resp => resp.json())
  }
}



// WEBPACK FOOTER //
// ./src/api/translations.js